
// this code handles basic requests to the backend API

export default async function requestHandler(path, method, authorization, body = null) {
    
  
  // we check for body so we dont send malformed requests
  if(body==null) {
        const response = await fetch(
      `${process.env.REACT_APP_BACKEND_IP === "localhost" ? "http://" :  "https://"}${process.env.REACT_APP_BACKEND_IP}${process.env.REACT_APP_BACKEND_IP === "localhost" ? `:${process.env.REACT_APP_BACKEND_PORT}` : ""}/${path}`,
      {
        method: method,
        headers: {
          "Content-Type": "application/json",
          Authorization: authorization,
        },

      }
    );
    const result = await response.json();
    return result;
}
    else {
      const response = await fetch(
          `${process.env.REACT_APP_BACKEND_IP === "localhost" ? "http://" :  "https://"}${process.env.REACT_APP_BACKEND_IP}${process.env.REACT_APP_BACKEND_IP === "localhost" ? `:${process.env.REACT_APP_BACKEND_PORT}` : ""}/${path}`,
          {
            method: method,
            headers: {
              "Content-Type": "application/json",
              Authorization: authorization,
            },
            body: JSON.stringify(body)
          }
        );
        const result = await response.json();
        return result;
    }
    

}
